import { toCsv } from "../growth";

export type Cell = string | number | null;

/** Offers `rows` (under `header`) as a CSV file named `fileName`. */
export function downloadCsv(fileName: string, header: readonly string[], rows: readonly (readonly Cell[])[]) {
  const url = URL.createObjectURL(new Blob([toCsv([header, ...rows])], { type: "text/csv;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

/**
 * Every chart's table view and CSV download (DESIGN.md decision 9; aggregates
 * only): numbers right-aligned, null as "—".
 */
export function DataTable({
  summary = "Table view",
  header,
  rows,
  fileName,
  format = (value) => value.toLocaleString(),
}: {
  summary?: string;
  header: readonly string[];
  rows: readonly (readonly Cell[])[];
  fileName: string;
  format?: (value: number) => string;
}) {
  return (
    <details>
      <summary>{summary}</summary>
      <p>
        <button type="button" className="button-quiet" onClick={() => downloadCsv(fileName, header, rows)}>
          Download CSV
        </button>
      </p>
      <div className="table-scroll">
        <table>
          <thead>
            <tr>
              {header.map((name, i) => (
                <th key={name} className={i === 0 ? undefined : "num"}>
                  {name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, r) => (
              <tr key={r}>
                {row.map((cell, i) =>
                  i === 0 ? (
                    <td key={i}>{cell ?? "—"}</td>
                  ) : (
                    <td key={i} className="num">
                      {cell === null ? "—" : typeof cell === "number" ? format(cell) : cell}
                    </td>
                  ),
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </details>
  );
}
